import React from 'react';

export const noData = <span className="no-data">No data yet</span>;
